import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { RadioInputField } from "../../components/ReactHooksFormFields/RadioInputField";
import MainPageDialog from "../../components/mainPageDialog";
import { InputField } from "../../components/ReactHooksFormFields/inputField";
import { ReactSelectField } from "../../components/ReactHooksFormFields/ReactSelectField";
import { MaskField } from "../../components/ReactHooksFormFields/MaskField";
import { useGetDemographicListingQuery } from "../../redux/service/demographic_services";
import { getUser } from "../../userStore";
import FullScreenLoader from "../../components/FullScreenLoader";
import { useSavePaymentMutation } from "../../redux/service/billing_services";
import { formattedDatePp } from "../../utils/common_lib";
import { toast } from "react-toastify";

function OnlinePaymentDialog({
  paymentKeys,
  onlinePaymentDialog,
  setOnlinePaymentDialog,
  setPreviewData,
}) {
  const user = getUser();
  const { data: demographicsMetaRes, isLoading } =
    useGetDemographicListingQuery({ show_all: true });
  const [savePayment] = useSavePaymentMutation();
  const {
    control,
    setValue,
    formState: { errors },
    handleSubmit,
    setFocus,
  } = useForm({
    defaultValues: {
      methord: "Card",
      account_type: "Checking",
      holder_type: "Personal",
    },
  });
  const methord = useWatch({ control, name: "methord" });
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    tokenizedPaymentMethod: null,
    completedTransaction: null,
    isPayButtonDisabled: true,
    errorMessage: "",
    loading: false,
  });
  let staxJsInstance = useRef(null);
  useLayoutEffect(() => {
    if (onlinePaymentDialog) {
      const StaxJs = window.StaxJs;
      const staxJs = new StaxJs(paymentKeys?.omni_web_token, {
        number: {
          id: "card-number",
          placeholder: "xxxx xxxx xxxx xxxx",
          style:
            " border:1px solid #d1d5db; border-radius:5px; height: 30px; width: 95%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300; padding-left:5px",
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style:
            "border:1px solid #d1d5db; border-radius:5px; height: 33px; width: 93%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300; padding-left:5px",
        },
      });

      staxJs.showCardForm().then((handler) => {
        console.log("form loaded! :^)");
        // handler.setTestPan("4111111111111111");
        // handler.setTestCvv("123");
      });

      staxJs.on("card_form_complete", (message) => {
        console.log("card_form_complete", message);
        setState({ ...state, isPayButtonDisabled: false });
      });

      staxJs.on("card_form_uncomplete", (message) => {
        console.log("card_form_uncomplete", message);
        setState({ ...state, isPayButtonDisabled: true });
      });
      staxJsInstance.current = staxJs;
    }
  }, [methord, onlinePaymentDialog]);

  useEffect(() => {
    if (user) {
      setValue("firstname", user?.fname);
      setValue("lastname", user?.lname);
      setValue("email", user?.email);
      setValue("address_1", user?.Address1);
      setValue("address_2", user?.Address2);
      setValue("address_city", user?.city);
      setValue("phone", user?.PhoneAdditional1);
      setValue("address_zip", user?.zip);
      setValue("address_state", user?.state);
      setValue("address_1", user?.street);
      setValue("address_2", user?.street1);
      setValue("phone", user?.phone);
    }
  }, []);
  useEffect(() => {
    setFocus("total");
  }, [setFocus]);
  const getPaymentInfo = (data) => {
    return {
      amount: data.total,
      method: "credit_card",
      payment_date: formattedDatePp(new Date(), "YYYY-MM-DD"),
      amount_paid_credit: 0,
      amount_paid_debit: data.total,
      balance: "",
      billing_charge_id: "",
      charge_id: "",
      comments: data.comments ? data.comments : "",
      copay_and_advance_id: "",
      id: "",
      location_id: user?.location_id,
      card_expiry_date: data?.card_exp ? data.card_exp : "",
      card_number: data?.card_number ? data.card_number : "",
      card_type_id: data?.card_type_id || "0",
      check_date: data?.check_date || "",
      check_number: data?.check_number || "",
      is_active: true,
      is_default: true,
      is_paid: data?.is_paid ? data?.is_paid : false,
      ledger_account_id: data.ledger_account_id || "",
      ledger_account_name: data.ledger_account_name || "",
      omni_paid: data.omni_paid ? data.omni_paid : false,
      paid: data.paid ? data.paid : false,
      patient_id: data.pid,
      payment_type_id: 4,
      pid: user?.pid,
    };
  };
  const handlePay = (data) => {
    setLoading(true);
    let extraDetails = {
      total: data?.total,
      firstname: data?.firstname,
      lastname: data?.lastname,
      company: "",
      email: data?.email,
      phone: data?.phone,
      address_1: data.address_1,
      address_2: data.address_2,
      address_city: data.address_city,
      address_state: data.address_state,
      address_zip: data.address_zip,
      address_country: "USA",
      url: "https://omni.fattmerchant.com/#/bill/",
      meta: {
        reference: "invoice-reference-num",
        memo: "notes about this transaction",
        tax: 0,
        practice_id: user?.practice_id,
        ethizo_user_id: user?.id,
        pid: user?.pid,
        transaction_type: "charge",
        charge: {
          charge_id: "",
          location_id: user?.location_id,
        },
        payment_type: "patientadvance",
        subtotal: data.total,
        location_id: user?.location_id,
        payment_date: formattedDatePp(new Date(), "YYYY-MM-DD"),
        check_number: "",
        check_date: "",
        bank: "",
        card_number: "",
        card_type: "",
        card_expiary_date: "",
        payment_info: getPaymentInfo(data),
        advance_payment: getPaymentInfo(data),
      },
    };
    console.log(extraDetails, "extraDetails");
    if (methord == "bank") {
      extraDetails.person_name =
        extraDetails.firstname + " " + extraDetails.lastname;
      extraDetails.method = "bank";
      extraDetails.bank_type = data.bank_type || "checking";
      extraDetails.bank_name = data.bank_name;
      extraDetails.bank_account = data.bank_account;
      extraDetails.bank_routing = data.bank_routing;
      extraDetails.bank_holder_type = data.bank_holder_type || "personal";
      extraDetails.validate = false;
      extraDetails.meta.bank = data.bank_name;
    } else {
      extraDetails.month = data?.card_exp?.split("/")[0];
      extraDetails.year = data?.card_exp?.split("/")[1];
    }
    staxJsInstance?.current
      ?.pay(extraDetails)
      .then((completedTransaction) => {
        console.log(
          "successfully paid. here's the transaction:",
          completedTransaction
        );
        setState({ ...state, completedTransaction });

        let obj = {
          ethizo_user_id: extraDetails?.meta?.ethizo_user_id,
          location_id: extraDetails?.meta?.location_id,
          payment_type: "patientadvance",
          pid: extraDetails?.meta?.pid,
          practice_id: extraDetails?.meta?.practice_id,
          transaction_id: completedTransaction?.child_transactions[0]?.id,
          transaction_type: "charge",
        };
        // console.log(obj,"heree")
        savePayment(obj).then((res) => {
          setLoading(false);
          if (res?.data?.response?.code == 0) {
            toast.success(res?.data?.response?.msg);
            setOnlinePaymentDialog(false);
            // if (res?.data?.response?.data?.invoice_info?.invoice_hash){
            //    setPreviewData(res?.data?.response?.data?.invoice_info?.invoice_hash)
            // }
          } else {
            toast.error(res?.data?.response?.msg);
          }
        });
      })
      .catch((e) => {
        setLoading(false);
        setState({
          ...state,
          isPayButtonDisabled: false,
          loading: false,
          errorMessage: JSON.stringify(e || "check network tab"),
        });
        toast.error("Somrthing Went Wrong");
      });
  };
  const footerList = [
    {
      type: "cancel",
      action: () => closeHandler(),
      title: "Cancel",
    },
    {
      id: "paybutton",
      title: "Pay",
      type: "save",
      // disabled: methord!="bank" && state?.isPayButtonDisabled,
      action: handleSubmit(handlePay),
    },
  ];
  const closeHandler = () => {
    setOnlinePaymentDialog(false);
  };
  return (
    <>
      {onlinePaymentDialog && (
        <MainPageDialog
          opacity="opacity-0"
          title="Online Payment"
          footer={true}
          maxHeight={true}
          footerList={footerList}
          modalSize="md"
          onCancelHandler={() => closeHandler()}>
          {loading && <FullScreenLoader />}
          <div className="">
            <p className="font-semibold">Billing Details</p>
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="total"
                  title="Amount"
                  type="number"
                  rules={{
                    required: {
                      value: true,
                    },
                    pattern: {
                      value: /^(?=.*[1-9])\d*\.?\d+$/,
                      message: "Invalid Number",
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-9"></div>
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="firstname"
                  title="First Name"
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="lastname"
                  title="Last Name"
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="email"
                  title="Email"
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="phone"
                  title="Phone"
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-6 mt-3">
                <InputField
                  control={control}
                  name="address_1"
                  title="Billing Address"
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-6 mt-3">
                <InputField
                  control={control}
                  name="address_2"
                  title="Address Line 2"
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="address_city"
                  title="City"
                  rules={{
                    required: {
                      value: true,
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-3 mt-3">
                <ReactSelectField
                  maxMenuHeight={165}
                  title="State"
                  uniqueKey="id"
                  showLabel="id"
                  name="address_state"
                  optionData={demographicsMetaRes?.data?.state}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select state",
                    },
                  }}
                  autoComplete="nope"
                />
              </div>
              <div className="col-span-3 mt-3">
                <InputField
                  control={control}
                  name="address_zip"
                  title="Zip"
                  rules={{
                    required: { value: true },
                    pattern: {
                      value: /^[0-9]{5}$|^[0-9]{9}$/,
                      message: "Zip Number length should be 5 or 9",
                    },
                  }}
                  errors={errors}
                  autoComplete="nope"
                />
              </div>
            </div>
            <p className="my-3 text-lg font-semibold">Payment Method</p>
            <div className="bg-gray-100 p-2 rounded mt-2">
              <RadioInputField
                control={control}
                errors={errors}
                name={"methord"}
                rules={{
                  required: { value: true },
                }}
                data={[
                  {
                    label: "Card",
                    key: "Card",
                  },
                ]}
              />
            </div>
            <div className="bg-gray-100 p-2 rounded mt-2">
              <RadioInputField
                control={control}
                errors={errors}
                name={"methord"}
                rules={{
                  required: { value: true },
                }}
                data={[
                  {
                    label: "Bank",
                    key: "bank",
                  },
                ]}
              />
            </div>

            {methord == "Card" ? (
              <>
                <div className=" mt-3 ">
                  <div className="grid grid-cols-12 gap-1 ">
                    <span className="mb-1 text-xs col-span-4">
                      Card Number<span className="text-red-500">*</span>
                    </span>
                    <span className=" text-xs col-span-3">
                      Expiration<span className="text-red-500">*</span>
                    </span>
                    <span className="mb-1 text-xs col-span-2">
                      CVV<span className="text-red-500">*</span>
                    </span>
                  </div>
                  <div
                    id="card-element"
                    className=" grid grid-cols-12 flex items-start gap-1">
                    <div
                      id="card-number"
                      className="card-number col-span-4 pt-2 "
                    />
                    <div className="col-span-3 -pt-10">
                      <MaskField
                        mask="99/9999"
                        name="card_exp"
                        placeholder="MM/YYYY"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        errors={errors}
                        autoComplete="nope"
                      />
                    </div>
                    <div
                      id="card-cvv"
                      className="card-cvv col-span-2 w-full pt-1.5"
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="grid grid-cols-12 gap-4 mb-20 mt-4">
                <>
                  <div className="col-span-8">
                    <InputField
                      control={control}
                      name="bank_name"
                      title="Bank Name"
                      rules={{
                        required: {
                          value: true,
                        },
                      }}
                      errors={errors}
                      autoComplete="nope"
                    />
                  </div>
                  <div className="col-span-4"></div>
                  <div className="col-span-4">
                    <InputField
                      control={control}
                      name="bank_routing"
                      title="Routing Number"
                      rules={{
                        required: {
                          value: true,
                        },
                      }}
                      errors={errors}
                      autoComplete="nope"
                    />
                  </div>
                  <div className="col-span-4">
                    <InputField
                      control={control}
                      name="bank_account"
                      title="Account Number"
                      rules={{
                        required: {
                          value: true,
                        },
                      }}
                      errors={errors}
                      autoComplete="nope"
                    />
                  </div>
                  <div className="col-span-12">
                    <RadioInputField
                      title="Account Type"
                      control={control}
                      errors={errors}
                      name={"bank_type"}
                      rules={{
                        required: { value: true },
                      }}
                      defaultValue="checking"
                      data={[
                        {
                          label: "Checking",
                          key: "checking",
                        },
                        {
                          label: "Saving",
                          key: "saving",
                        },
                      ]}
                    />

                    <RadioInputField
                      titleCustomStyle="mt-4"
                      title="Bank Holder Type"
                      control={control}
                      errors={errors}
                      name={"bank_holder_type"}
                      rules={{
                        required: { value: true },
                      }}
                      defaultValue="personal"
                      data={[
                        {
                          label: "Personal",
                          key: "personal",
                        },
                        {
                          label: "Business",
                          key: "business",
                        },
                      ]}
                    />
                  </div>
                </>
              </div>
            )}
          </div>
        </MainPageDialog>
      )}
    </>
  );
}

export default OnlinePaymentDialog;
